// @ts-nocheck

import config from '../config/app.config';
import { getLang } from '../i18n/l10n';
import { StreamingActionTypes } from '../types/actions/common';

import apiActionCreators from './api';

const { makeApiCall } = apiActionCreators;
const { streamingUrl } = config;

/**
 * FIXME
 * [description]
 * @return {[type]} [description]
 */
const getStreamingUrl = () => ({
  type: StreamingActionTypes.GET_STREAMINGURL,
});

/**
 * FIXME
 * [description]
 * @param  {[type]} options.response [description]
 * @param  {[type]} options.matchId  [description]
 * @return {[type]}                  [description]
 */
const getStreamingUrlOk = ({ response, matchId }) => ({
  type: StreamingActionTypes.GET_STREAMINGURL_OK,
  payload: {
    response,
    matchId,
  },
});

/**
 * FIXME
 * [description]
 * @param  {[type]} options.error [description]
 * @return {[type]}               [description]
 */
const getStreamingUrlKo = ({ error }) => ({
  type: StreamingActionTypes.GET_STREAMINGURL_KO,
  payload: {
    error,
  },
});

/**
 * FIXME
 * [description]
 * @param  {[type]} { matchId,      stream }) [description]
 * @return {[type]}    [description]
 */
const doGetStreamingUrl =
  ({ matchId, stream }) =>
  (dispatch) => {
    dispatch({ type: StreamingActionTypes.GET_STREAMINGURL });

    const form = `params=${JSON.stringify({ match_id: matchId, stream })}`;

    const url = streamingUrl[getLang()];
    const method = 'POST';
    const credentials = 'same-origin';
    const options = {
      url,
      method,
      credentials,
      body: form,
      forwardWamUserIp: true,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    };
    const hooks = {
      success: (response) => {
        dispatch(getStreamingUrlOk({ response, matchId }));
      },
      failure: (error) => {
        dispatch(getStreamingUrlKo({ error }));
      },
    };

    dispatch(makeApiCall({ options, hooks }));
  };

export default {
  getStreamingUrl,
  getStreamingUrlOk,
  getStreamingUrlKo,
  doGetStreamingUrl,
};
